
import { NgModule, Injectable } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';

import { AuthService } from './shared/auth/auth.service';
import { AuthGuard } from './shared/auth/auth-guard.service';

import * as $ from 'jquery';
import { LoadingModule } from 'ngx-loading';
import { GroupService } from 'app/settings/groups/shared/group.service';
import { LaddaModule } from 'angular2-ladda';

import { AngularFireModule, FirebaseAppConfig, FirebaseAppName } from 'angularfire2';
/* import { AngularFireDatabaseModule } from 'angularfire2/database'; */
import { AngularFireAuthModule } from 'angularfire2/auth';

import { environment } from '../environments/environment';
import { AngularFireStorage } from 'angularfire2/storage';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import { UserService } from './users/shared/user.service';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { CustomInterceptor } from 'app/shared/custom.interceptor';
import { RoleService } from 'app/settings/roles/shared/role.service';
import { GlobalService } from './shared/global.service';
import { ProfileEditComponent } from 'app/users/profile-edit/profile-edit.component';
import { ToastModule, ToastOptions } from 'ng2-toastr';
import { ForgotPasswordComponent } from './forgotpassword/forgotPassword.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SettingService } from './settings/shared/setting.service';
import { UserFilterPipe } from './users/users.pipe';
import { StorageItemService } from './shared/storage-items/shared/storage-item.service';
import { UnitService } from './settings/units/shared/unit.service';
import { BuildingService } from './settings/buildings/shared/building.service';
import { SocketService } from './shared/socket.service';
import { ClassbookService } from './classbook/shared/classbook.service';
import { ClassBookTemplateService } from './settings/class-book-templates/shared/class-book-template.service';
import { PremadeMessageService } from './settings/premade-messages/shared/premade-message.service';
import { ClassBookFolderService } from './settings/class-book-folders/shared/class-book-folder.service';
import { ExportService } from './settings/exports/shared/export.service';
import { CalendarModule } from 'angular-calendar';
import { StudentFilterPipe } from './students/shared/student.pipe';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { LogService } from './settings/logs/shared/log.service';

registerLocaleData(localeDe);

@Injectable()
export class CustomOption extends ToastOptions {
  animate = 'flyRight'; // you can pass any options to override defaults
  dismiss = 'auto';
  toastLife = 3000;
}

// Single-image build: environment.prod.ts takes the Firebase config from /env.js at
// runtime. AOT inlines useValue providers at compile time and would bake in null, so
// AngularFire gets its config through this factory instead of initializeApp().
export function firebaseConfigFactory() {
    return environment.firebase;
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    imports: [
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        NgbModule.forRoot(),
        CalendarModule.forRoot(),
        LoadingModule,
        ToastModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        LaddaModule.forRoot({
            style: 'expand-left',
            spinnerSize: 30,
            spinnerColor: 'black',
            spinnerLines: 12
        }),
        AngularFireModule,
        /*     AngularFireDatabaseModule, */
        AngularFireAuthModule,
        HttpClientModule,
    ],
    declarations: [
        AppComponent,
        FullLayoutComponent,
        ProfileEditComponent,
        LoginComponent,
        ForgotPasswordComponent,
        RegisterComponent
    ],
    providers: [
        { provide: FirebaseAppConfig, useFactory: firebaseConfigFactory },
        { provide: FirebaseAppName, useValue: undefined },
        AuthService,
        LogService,
        AuthGuard,
        GlobalService,
        StorageItemService,
        RoleService,
        UnitService,
        BuildingService,
        SettingService,
        GroupService,
        ExportService,
        UserService,
        ClassbookService,
        ClassBookTemplateService,
        PremadeMessageService,
        ClassBookFolderService,
        UserFilterPipe,
        StudentFilterPipe,
        SocketService,
        AngularFirestore,
        AngularFireStorage,
        AngularFireDatabase,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CustomInterceptor,
            multi: true,
        },
        { provide: ToastOptions, useClass: CustomOption },
        /* {
            provide: NgbDateParserFormatter,
            useFactory: () => { return new NgbDateParserFormatter('DD-MM-YYYY') },
        } */
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts